var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutube = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    width: 40,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 71.412065 50",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style3",
    type: "text/css"
  }, "\r\n    .st2{fill:#282828}\r\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g5",
    transform: "scale(.58824)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7",
    fill: "#282828",
    fillOpacity: 1,
    d: "M118.9 13.3c-1.4-5.2-5.5-9.3-10.7-10.7C98.7 0 60.7 0 60.7 0s-38 0-47.5 2.5C8.1 3.9 3.9 8.1 2.5 13.3 0 22.8 0 42.5 0 42.5s0 19.8 2.5 29.2C3.9 76.9 8 81 13.2 82.4 22.8 85 60.7 85 60.7 85s38 0 47.5-2.5c5.2-1.4 9.3-5.5 10.7-10.7 2.5-9.5 2.5-29.2 2.5-29.2s.1-19.8-2.5-29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon9",
    fill: "#fff",
    d: "M80.2 42.5 48.6 24.3v36.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.9bf5d8e251da1b79eba2caae6cb506d9.svg";